import React from 'react';

/**
 * ポップアップ共通
 *
 * グレー背景・タイトル・×ボタンがあらかじめ設定されているポップアップです。
 * このコンポーネントはステートレスです。
 *
 * // 呼び出し方の例
 * render() {
 *     let popupContents = (<div>ポップアップの内容</div>);
 *     return (<PopupContainer title="ポップアップタイトル" onClose={this.onClose}>...</PopupContainer>);
 * }
 *
 * 以下の内容を指定することができます。
 * - title : ポップアップタイトル
 * - titleClassName : ポップアップタイトルにCSSのクラスを指定します
 * - contents : ポップアップの内容をDOMオブジェクトで指定します
 * - onClose : ポップアップを閉じたときに処理が呼ばれます
 */
export default function PopupContainer({
  title = '',
  titleClassName = '',
  onClose,
  onBeforeClose,
  children,
}: {
  title?: string,
  titleClassName?: string,
  onClose?: () => void,
  onBeforeClose?: () => boolean,
  children: React.ReactNode,
}) {
  const overlayRef = React.useRef<HTMLDivElement>(null);
  const popupRef = React.useRef<HTMLDivElement>(null);

  const handleClose = () => {
    // 閉じる前に確認ポップアップを出す処理
    if (onBeforeClose) {
      const result = onBeforeClose();
      if (!result) {
        return;
      }
    }
    const overlay = overlayRef.current;
    if (overlay !== null) {
      window.jQuery(overlay).removeClass('pop_on');
    }
    const popup = popupRef.current;
    if (popup !== null) {
      window.jQuery(popup).removeClass('pop_on');
    }
    if (onClose) {
      window.setTimeout(() => onClose(), 500);
    }
  };

  React.useEffect(() => {
    document.onkeydown = (e: KeyboardEvent) => {
      const key = e.keyCode !== 0 ? e.keyCode : e.charCode;
      if (key === 27) { // ESCキーで閉じる
        handleClose();
        return;
      }
      if (key === 13) { // テキスト入力中のEnterでフォームを送信しない
        if (e.target instanceof HTMLInputElement && e.target.name === 'text') {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    };
    //Frekul.CommonUI.PopupManager.disableBodyScroll();
    // $('body').css({
    //   position: 'fixed',
    //   width: '100%',
    //   top: -pointY,
    // });
    window.Frekul.CommonUI.PopupManager.resizeAllPopups();
    // this.optimizePopupHeight();
    const overlay = overlayRef.current;
    if (overlay !== null) {
      window.jQuery(overlay).addClass('pop_on');
    }
    const popup = popupRef.current;
    if (popup !== null) {
      window.jQuery(popup).addClass('pop_on');
    }
    return () => {
      //Frekul.CommonUI.PopupManager.enableBodyScroll();
    };
  });

  return (
    <>
      { /* eslint-disable-next-line max-len */}
      { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ }
      <div onClick={(e) => { e.stopPropagation(); }}>
        { /* eslint-disable-next-line max-len */}
        { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ }
        <div ref={overlayRef} className="overlay" onClick={(e) => { handleClose(); }} />
        { /* eslint-disable-next-line max-len */}
        { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ }
        <div ref={popupRef} className="popup size" onClick={(e) => { e.stopPropagation(); }} onSubmit={(e) => { e.stopPropagation(); }}>
          <h1 className={titleClassName}>
            <div>{title}</div>
            { /* eslint-disable-next-line max-len */}
            { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */ }
            <img src="/img/popup/popup_cancel.svg" alt="cancel" className="close_popup" onClick={(e) => { handleClose(); }} />
          </h1>
          <div className="popup_inner">
            <div className="popup_inner_content">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
